import { render, staticRenderFns } from "./NavigationModal.vue?vue&type=template&id=5af031e9&scoped=true"
import script from "./NavigationModal.vue?vue&type=script&lang=js"
export * from "./NavigationModal.vue?vue&type=script&lang=js"
import style0 from "./NavigationModal.vue?vue&type=style&index=0&id=5af031e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af031e9",
  null
  
)

export default component.exports